import { render, staticRenderFns } from "./FsMultipleInfo.vue?vue&type=template&id=2f528d7b&"
import script from "./FsMultipleInfo.vue?vue&type=script&lang=js&"
export * from "./FsMultipleInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports